<div class="grid p-24">
  <div class="d-flex flex gap-8 g-col-12">
    <kendo-grid
      [data]="gridData$"
      scrollable="none"
      [pageable]="true"
      [pageSize]="itemsPerPage()"
      [skip]="gridState.skip"
      [sortable]="true"
      [sort]="gridState.sort"
      [filterable]="true"
      (pageChange)="onPageChange($event, itemsPerPage(), params, reload$)"
      [filter]="gridState.filter"
      [loading]="isLoadingGridData$.value"
      (dataStateChange)="onDataStateChange($event)"
      (cellClick)="onGridRowClick($event)">
      <kendo-grid-column field="id" [filterClass]="'filter-button'" [headerClass]="'filter-button'" [width]="64">
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem>
          <button kendoTooltip type="button" [showOn]="'hover'" title="{{ 'REMOVE_FILTERS' | translate | capitalize }}">
            <i tabindex="0" (keydown.enter)="clearCustomFilters(itemsPerPage(), params, reload$)" class="rc-icon-clear-filter" (click)="clearCustomFilters(itemsPerPage(), params, reload$)"></i>
          </button>
          <ng-template kendoGridCellTemplate let-dataItem>
            <kendo-checkbox  [checkedState]="dataItem.id === selectedOrderItem()?.id" (checkedStateChange)="removeOrSetSelection($event, dataItem)"></kendo-checkbox>
          </ng-template>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="article.normalizedNumber" title="{{ 'ARTICLE' | translate }}" [sortable]="false">
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-textbox (valueChange)="setCustomFilter($event, 'article.normalizedNumber', params, reload$)" [value]="getParamValue('article.normalizedNumber', params)"></kendo-textbox>
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.articleNumber }}
          </ng-template>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="amount" title="{{ 'AMOUNT' | translate }}" [sortable]="false" [filterable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="d-flex w-100 justify-content-end">
              <span>{{ dataItem.amount - dataItem.mappedAmount | kendoNumber: amountFormat }}</span>
            </div>
          </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="lineTotal" title="{{ 'LINE_TOTAL' | translate }}" [sortable]="false" [filterable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="d-flex w-100 justify-content-end">
            <span> {{ dataItem.lineTotal | kendoNumber: decimalFormat }}</span>
          </div>

        </ng-template>
      </kendo-grid-column>

      <ng-template kendoGridNoRecordsTemplate>
        @if(!this.isLoadingGridData$.value) {
          <div class="empty-grid-template">
            <div class="grid-logo">
              <i class="rc-icon-store fc-primary-500"></i>
            </div>
            <div class="grid-message">
              {{ "EMPTY_GRID_RESULT" | translate: { entity: "CLIENT_ORDERS" | translate } | capitalize }}
            </div>
          </div>
        }
      </ng-template>

      <ng-template kendoGridLoadingTemplate>
        <rc-list-skeleton [userSettings]="userSettings()!" [colAmount]="4" [state]="gridState" [itemsPerPage]="itemsPerPage()" [forceCustomItemsPerPage]="true"></rc-list-skeleton>
      </ng-template>
    </kendo-grid>
  </div>
</div>
